import { DATA_LOADING_STATES, METRIC_NAMES, SORT_DIRECTION } from '@config/Consts';

export default {
  dataStatus: DATA_LOADING_STATES.NONE,
  lastTimeDataUpdated: null,
  conversations: null,
  filter: {
    agents: [],
    status: null,
    liveIntentIds: [],
  },
  sort: {
    columnName: METRIC_NAMES.CONVERSATIONS_RESPONSE_TIME,
    direction: SORT_DIRECTION.ASCENDING,
  },
  intents: {
    dataStatus: DATA_LOADING_STATES.NONE,
    intentsPerDomain: [],
  },
};
